import { createTheme } from '@mui/material';
import { MainTheme } from './MainTheme';
export const DarkTheme = createTheme({
  ...MainTheme,
});

DarkTheme.typography.h7 =  {
  ...MainTheme.typography.h7,
  color: "#ffffff",
}